export const Icon = ({
  name,
  size = 24,
  className,
  color,
  ...props
  }) => {
    return (
      <>
        {name === 'check' && (
          <svg
            width={size}
            height={size}
            viewBox="-7 -9 24 24"
            fill="none"
            {...props}
          >
            <path d="M1 3L4 6L9 1" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        )}
        {name === 'play' && (
          <svg width={size} height={size} fill={color} viewBox="0 0 24 24"><path d="M3 22v-20l18 10-18 10z"/></svg>
         )}
         {name === 'star' && (
          <svg width={size-3} height={size-3} fill={color} viewBox="0 0 24 26"><path d="M12 17.27l-5.18 2.73 1.64-5.82-4.54-3.91 5.88-.51 2.18-5.38 2.18 5.38 5.88.51-4.54 3.91 1.64 5.82z"/></svg>
          )}
      </>
    );
  };